import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ContestTab from './contestTab/ContestTab';
import classes from './ContestTabs.module.css';

const ContestTabs = () => {
  
  const navigate = useNavigate();
  const {activeContests, currentContestId} = useSelector((state) => state.contest);
  const handleContestChange = (newContestId) => {
      // dispatch(contestActions.setCurrentContestId(newContestId));
    navigate(`/${newContestId}`);
  };

  return (
    <nav className={classes.contestTabs}>
      {activeContests.map((contest) => {
        return (
          <ContestTab
            key={contest.id}
            contest={contest}
            isActive={String( currentContestId) === String(contest.id)}
            onClick={() => handleContestChange(contest.id)}
          />
        );
      })}
    </nav>
  );
};

export default ContestTabs;
